import httpClient from "../../clients/httpClient";
import {
    AppStoreDashboardFilter,
    IAppStoreCheckRunResponse,
    IAppStoreDashboardResponse,
    IAppStoreIssueResponse,
} from "../../state/types/app-store-monitor";
import { IAppleSetupQueueResponse } from "../../state/types/apple-setup";

const ADMIN_BASE = "/api/v1/admin/app-store-monitor";

const RUN_CHECK_TIMEOUT_MS = 90_000;

export const getAppStoreDashboard = (filter: AppStoreDashboardFilter) => {
    return httpClient.get<IAppStoreDashboardResponse>(`${ADMIN_BASE}/issues`, {
        params: { filter },
    });
};

export const getAppStoreIssue = (id: number) => {
    return httpClient.get<IAppStoreIssueResponse>(`${ADMIN_BASE}/issues/${id}`);
};

export const runAppStoreCheck = () => {
    return httpClient.post<IAppStoreCheckRunResponse>(
        `${ADMIN_BASE}/run-check`,
        {},
        { timeout: RUN_CHECK_TIMEOUT_MS }
    );
};

export const sendAppStoreAlert = (id: number) => {
    return httpClient.post<IAppStoreIssueResponse>(
        `${ADMIN_BASE}/issues/${id}/send-alert`,
        {}
    );
};

const ADMIN_ORG_BASE = "/api/v1/admin/organizations";

export const getAppleSetupQueue = () => {
    return httpClient.get<IAppleSetupQueueResponse>(
        `${ADMIN_BASE}/apple-setup-queue`
    );
};

// Success response is a raw .p8 file (application/x-pem-file), returned as a
// string by axios's default transform. We intentionally do NOT set
// responseType: "blob" so that error responses (403/404) keep their JSON body,
// letting the shared interceptor surface the real backend message.
export const retrieveAppleKey = (orgId: number, reason: string) => {
    return httpClient.post<string>(
        `${ADMIN_ORG_BASE}/${orgId}/apple-setup/retrieve-key`,
        { reason }
    );
};

export const completeAppleSetup = (orgId: number) => {
    return httpClient.post(`${ADMIN_ORG_BASE}/${orgId}/apple-setup/complete`, {});
};

export const sendAppleNeedsCorrection = (orgId: number, note: string) => {
    return httpClient.post(
        `${ADMIN_ORG_BASE}/${orgId}/apple-setup/needs-correction`,
        { note }
    );
};
